import ProfileTableService from 'app/admin/profile/service/ProfileTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'profileTable',
	text: 'Profile',
	topic: 'profile',
	service: ProfileTableService,
	icon: 'person',
	editFormState: item => `/profile/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'search', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'name',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'name',
			text: 'Name',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'magic',
			text: 'Magic',
			type: 'text',
			sortable: false,
			disablePadding: false
		},
		{
			key: 'status',
			text: 'Status',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'visualCaptchaType.name',
			text: 'Visual Captcha Type',
			textKey: 'visualCaptchaType.name',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'audioCaptchaType.name',
			text: 'Audio Captcha Type',
			textKey: 'audioCaptchaType.name',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function ProfileTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('profileTable', reducer('profileTable'))(ProfileTable);
